import {type FunctionalComponent, h, type VNode} from '@stencil/core';
import {getActiveBreakpoints} from '../../../utils/media';
import type {GuidedV2Emitters} from '../../guided2/models/eventNames';


interface MegaBannerProps {
  eventEmitters: GuidedV2Emitters;
  description?: string;
  text?: string;
  buttonText?: string;
  href?: string;
  target?: string|undefined;
  src?: string;
}


export const MegaBanner: FunctionalComponent<MegaBannerProps> = (props) => {
    const {
      text,
      buttonText,
      href,
      target,
      src,
      description,
      eventEmitters
    } = props;

    const { bannerClicked } = eventEmitters() ?? {};

    const handleMobileClick = (event) => {
        if (!getActiveBreakpoints().medium) {
          const clickEvent = bannerClicked?.emit?.({ url:href });
          if (!clickEvent.defaultPrevented) {
            window.open(href, target);
          }
        }
    };

    const handleBtnClick = (event) => {
        const clickEvent = bannerClicked?.emit?.({ url:href });
        if (clickEvent.defaultPrevented) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
    };

    return <div class="mega-banner__container" onClick={handleMobileClick}>
      <div class="mega-banner__text-section">
        {text && <h3 class="mega-banner__title">{text}</h3>}
        {description && <div class="mega-banner__subtitle">{description} </div>}
      </div>
      {buttonText && <qds-button
        class="mega-banner__button"
        size="large"
        href={href}
        importance='standard'
        text={buttonText}
        target={target}
        onClickCapture={handleBtnClick}
      ></qds-button>}
    </div> as VNode;
};
